<template>
  <div class="wrapper">
    <parallax
      class="page-header header-filter header-small"
      parallax-active="true"
      :style="headerStyle"
    >
      <div class="container">
        <div class="md-layout">
          <div
            class="md-layout-item md-size-66 md-small-size-100 mx-auto text-center"
          >
            <h2 class="title">Benachrichtigungen</h2>
            <h4>
              Nachrichten per E-Mail abbestellt.
            </h4>
          </div>
        </div>
      </div>
    </parallax>
    <div class="main main-raised">
      <div class="section section-about-description text-center pb-0">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-66 md-small-size-100 mx-auto">
              <div class="alert alert-danger" v-if="showError">
                <div class="container">
                  <h5>FEHLER!</h5>
                  Leider ist beim Abbestellen der E-Mails ein Fehler aufgetreten, bitte versuchen Sie es später erneut.
                </div>
              </div>
              <div class="alert alert-success" v-if="showSuccess">
                <div class="container">
                  <h5>ERFOLG!</h5>
                  Alle E-Mail Benachrichtigungen wurden abbestellt.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Mixins from "@/plugins/basicMixins";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  mixins: [Mixins.HeaderImage],
  components: {},
  data() {
    return {
      showSuccess: false,
      showError: false,
      image: require("@/assets/img/dorfladen/landscape-666927_1280.jpg")
    };
  },
  mounted() {
    this.deleteSubscriber(this.$route.params.id);
  },
  computed: {
    ...mapGetters(["backendServer"])
  },
  methods: {
    deleteSubscriber(subId) {
      let vm = this;
      let deleteUrl = this.backendServer + "subscriber/" + subId;
      axios
        .delete(deleteUrl)
        .then(function(response) {
          if (response.status == 204) {
            vm.showSuccess = true;
          } else {
            vm.showError = true;
          }
        })
        .catch(function(e) {
          vm.showError = true;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.mt-2 {
  margin-top: 1.5rem;
}
.section {
  padding: 20px 0 !important;
}
.alert .container {
  padding: 0 10px;
}
</style>
